import { View } from 'backbone.marionette';
import fixtures from './templates/fixtures.jst';
import empty_template from './templates/empty_template.jst';
import popup_teamplate from './templates/popup_teamplate.jst';
import './index.styl';
import _ from 'lodash';
import Modal from '../../../../../core/utils/Modal';
import Preloader from '../../../../../core/utils/Preloader';
import { User } from '../../../models';
import { redirectTo } from '../../../../../core/utils';

/**
 * @desc League LeagueFixturesView View Class
 * This class using on league loin page ('fantasy/league/:league_id/fixtures')
 */
export default class LeagueFixturesView extends View {
	getTemplate() {
		if (this.fixtures_ready) {
			return fixtures;
		}
		else {
			return empty_template;
		}
	}

	regions() {
		return {
			top_ad_banner: '.top-ad-banner',
		};
	}

	get className() {
		return "league-fixtures-page";
	}

	ui() {
		return {
			'change_round': '.js-change-round',
			'matchup': '.js-matchup',
		};
	}

	events() {
		return {
			'change @ui.change_round': 'updateFixture',
			'click @ui.matchup': 'alertMatchup'
		};
	}

	modelEvents() {
		return {
			'league:query:not:found': 'redirectToMyLeague',
		};
	}

	/**
	 *    Initialize view data
	 */
	async initialize() {
		this.liveScoresIntervalId = null;

		this.league_id = this.getOption('league_id');
		this.rounds = this.getOption('rounds');
		this.players = this.getOption('players');
		this.team = this.getOption();
		this.coach = this.getOption('coach');
		this.round_id = 0;
		this.fixtures_ready = false;

		this.initListeners();

		Preloader.show();

		await this.fetchData();
		this.setCurrentRound()
			.setCoach()
			.updateModel()
			.initLiveScores();

		Preloader.hide();
	}

	initListeners() {
		return this;
	}

	/**
	 * Get all base data for this class
	 * @returns {*|Promise.<Object>}
	 */
	fetchData() {
		return Promise.all([
			this.model.setShowUrl().set({
				start_round: ''
			}).fetch(
				{
					data: {
						id: this.league_id
					}
				}
			),
			this.rounds.fetch(),
			this.players.fetch(),
			this.coach.fetch()
		]);
	}

	initLiveScores() {
		if (this.current_round.get('status')==='active') {
			this.subscribeToLiveUpdates();
		}
		else {
			clearInterval(this.liveScoresIntervalId);
		}

		return this;
	}

	subscribeToLiveUpdates() {
		if (this.liveScoresIntervalId) {
			return this;
		}

		const updateInterval = 1000 * 60 * 1;
		this.liveScoresIntervalId = setInterval(() => this.liveUpdates(), updateInterval);
	}

	liveUpdates() {
		let active_match = this.current_round.active_match;

		if (active_match) {
			this.fetchData().then(() => {
				this.setCoach()
					.updateModel();
			});
		}
		else {
			this.rounds.fetch();
		}

		return this;
	}

	setCoach() {
		if (User.has_assistant_coach) {
			let bye_rounds = this.rounds
				.filter(
					round => round.get('is_bye') && round.get('status')==='scheduled'
				).map(round => round.toJSON());

			this.players.each(player => {
				player
					.setCoachStats({
						coach: this.coach.toJSON(),
						actual_round_id: this.current_round.get('id')
					})
					.setByRound({ bye_rounds });
			});
		}

		return this;
	}

	updateModel() {
		this.checkCurrentUser();

		this.model
			.set({
				players: this.players,
				players_by_id: _.keyBy(this.players.toJSON(), 'id'),
				rounds_collection: this.rounds,
				has_assistant_coach: User.has_assistant_coach
			})
			.updateFormData(this.rounds, false)
			.updateFinalsRounds();

		this.checkIsReadyFixtures();

		return this;
	}

	checkCurrentUser() {
		if (!this.model.checkLeagueMember()) {
			this.redirectToMyLeague();
		}
	}

	checkIsReadyFixtures() {
		let fixture = this.model.get('fixture');
		this.fixtures_ready = !_.isEmpty(fixture);
		if (this.fixtures_ready) {
			this.model
				.setFixtureList()
				.setAvatar();

			return this.updateView();
		}
		this.render();

		return this;
	}

	setCurrentRound() {
		let is_bye_rounds = this.model.get('bye_rounds'),
			current_round = is_bye_rounds ?
				this.rounds.actual :
				this.rounds.actualRoundWithoutBye,
			current_round_id = current_round.get('id'),
			round_status = current_round.get('status'),
			start_round = this.model.get('start_round');

		const fixture = this.model.get('fixture');
		const fixture_keys = Object.keys(fixture);
		const fixture_length = fixture_keys.length;
		const current_round_fixture = _.get(fixture, current_round_id, []);
		const last_available_fixture_id = fixture_keys[fixture_length - 1];
		const round_id_to_use = 
			_.isEmpty(current_round_fixture) ? Number(last_available_fixture_id) : current_round_id;

		this.current_round = current_round;
		this.round_id = (start_round <= current_round_id) ? round_id_to_use : start_round;
		this.model.set({ current_round: round_id_to_use, round_status });

		return this;
	}

	setCurrentFixture() {
		let fixtures = this.model.get('fixtures'),
			current_fixture = fixtures[this.round_id];
		this.model.set('current_fixture', current_fixture);

		return this;
	}

	setMatchupUrl() {
		let status = this.model.get('status'),
			id = this.league_id,
			matchup_url = (home_id, away_id, round) => {
				if (status==='scheduled') {
					return 'javascript:void(0)';
				}
				else {
					return `/fantasy/league/${id}/matchup/${home_id}/${away_id}/${round}`;
				}
			};

		this.model.set('matchup_url', matchup_url);

		return this;
	}

	updateView() {
		this.setCurrentFixture()
			.setMatchupUrl()
			.render();
	}

	updateFixture(element) {
		this.round_id = $(element.currentTarget).val();
		this.model.set('current_round', this.round_id);
		this.updateView();
	}

	alertMatchup() {
		let status = this.model.get('status');

		if (status==='scheduled') {
			Modal.create({
				template: popup_teamplate(),
				events: {
					'click .js-close': 'close'
				}
			});
		}
	}

	redirectToMyLeague() {
		redirectTo('/fantasy/leagues');
	}
}